var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import '@styles/shared/stylesheets/svgIcon.scss';
import React from 'react';
export const SvgIconBase = (_a) => {
    var { icon, className } = _a, rest = __rest(_a, ["icon", "className"]);
    if (isNullOrUndefined(icon)) {
        return null;
    }
    const classNames = ['svg-icon', className];
    const iconClassName = classNames.filter(Boolean).join(' ');
    const iconWithAriaHidden = React.cloneElement(icon, {
        'aria-hidden': true
    });
    return (_jsx("span", Object.assign({ className: iconClassName }, rest, { children: iconWithAriaHidden })));
};
